import React, { useEffect, useState, } from "react";
import axios from "axios";
import {
    Container,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Tabs,
    Tab,
    IconButton,
    Box,
    styled,
    tableCellClasses,
    TextField,
    CircularProgress,
    InputAdornment
} from "@mui/material";
import { makeApiRequest } from '../../../utils/api';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SchoolIcon from '@mui/icons-material/School';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import BorderAllIcon from '@mui/icons-material/BorderAll';
import DoneIcon from '@mui/icons-material/Done';
import { Grid } from "@mui/material";
import { formatDate } from "../../../helpers/timeHelper";
import OverflowTooltip from '../../../helpers/OverflowTooltip';
import { useNavigate } from 'react-router-dom';
import { Visibility } from "@mui/icons-material";
import { Search } from '@mui/icons-material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#F1F4F9",
        // color: theme.palette.common.white,
        fontWeight: "bold",
        color: "black"
    },
}));


const SubmitAssignment = () => {
    const [assignments, setAssignments] = useState([]);
    const [filteredAssignments, setFilteredAssignments] = useState([]);
    const [statusFilter, setStatusFilter] = useState("assigned");
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const fetchAssignments = async () => {
            setLoading(true);
            try {
                const response = await makeApiRequest('post', '/api/assignments/student/list', {
                    token: localStorage.getItem('authToken'),
                    id: localStorage.getItem('userid')
                });

                setAssignments(response.data);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching assignments:", error);
                setAssignments([]);
            }
        };
        fetchAssignments();
    }, []);


    useEffect(() => {
        let filtered = assignments;

        if (statusFilter !== "all") {
            filtered = filtered.filter(assignment => assignment.status === statusFilter);
        }

        if (searchQuery.trim() !== "") {
            filtered = filtered.filter(assignment =>
                assignment.stud_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                assignment.project_title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                assignment.created_by.toLowerCase().includes(searchQuery.toLowerCase()) ||
                assignment.batch_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                assignment.course_name.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }

        setFilteredAssignments(filtered);
    }, [statusFilter, assignments, searchQuery]);

    const openReview = (assignment) => {
        navigate(`/review-studentassignment`, { state: { id: assignment.id } });

    }
    if (loading) return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="400px"
        >
            <CircularProgress
                size={40}
                thickness={4}
                sx={{
                    color: '#481E82',
                }}
            />
        </Box>
    );

    return (
        <div style={{ minHeight: "100vh", maxWidth: '100%', margin: 'auto', padding: '24px', backgroundColor: "#F1F4F9", fontFamily: "Roboto" }}>
            <Box sx={{ height: "50px", display: "flex", alignItems: "center" }}>
                <Typography variant='h4' sx={{ color: "#481E82", fontWeight: "500", fontSize: { xs: '24px', sm: '34px' } }}>  View Assignments</Typography>
            </Box>
            <Tabs value={statusFilter} sx={{ py: 2, minHeight: 40, "& .MuiTab-root": { minHeight: 32, fontSize: "0.875rem" } }} onChange={(e, newValue) => setStatusFilter(newValue)}>
            <Tab icon={<BorderAllIcon />} iconPosition="start" label={`All (${assignments.length})`} value="all" />
                <Tab icon={<PeopleAltIcon />} iconPosition="start" label={`Pending With Staff (${assignments.filter(a => a.status === "submitted").length})`} value="submitted" />
                <Tab icon={<SchoolIcon />} iconPosition="start" label={`Pending With Student (${assignments.filter(a => a.status === "assigned").length})`} value="assigned" />
                <Tab icon={<CancelIcon />} iconPosition="start" label={`Rejected (${assignments.filter(a => a.status === "rejected").length})`} value="rejected" />
                <Tab icon={<CheckCircleIcon />} iconPosition="start" label={`Completed (${assignments.filter(a => a.status === "reviewed").length})`} value="reviewed" />
            </Tabs>

            <Box sx={{ backgroundColor: "white", p: 2, mt: 2 }}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={6} md={4} lg={3}> {/* Takes half width on medium+ screens */}
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            placeholder="Search"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{ width: "100%" }}
                        />

                    </Grid>
                </Grid>
            </Box>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>S.NO</StyledTableCell>
                            <StyledTableCell>Student Name</StyledTableCell>
                            <StyledTableCell>Project Title</StyledTableCell>
                            <StyledTableCell>Assigned By</StyledTableCell>
                            <StyledTableCell>Batch & Course</StyledTableCell>
                            <StyledTableCell>Module & Chapter</StyledTableCell>
                            <StyledTableCell>Action</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredAssignments.map((assignment, index) => (
                            <TableRow key={index}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{assignment.stud_name}<br /><Typography variant="body2" sx={{ fontSize: '13px', color: 'gray' }}>{assignment.stud_id}</Typography></TableCell>
                                <TableCell>{assignment.project_title}</TableCell>
                                <TableCell>{assignment.created_by}<br /><Typography variant="body2" sx={{ fontSize: '13px', color: 'gray' }}>{formatDate(assignment.assign_date)}</Typography></TableCell>
                                <TableCell>{assignment.batch_name}<br /><Typography variant="body2" sx={{ fontSize: '13px', color: 'gray' }}><OverflowTooltip>{assignment.course_name}</OverflowTooltip></Typography></TableCell>
                                <TableCell>{assignment.module_name}<br /><Typography variant="body2" sx={{ fontSize: '13px', color: 'gray' }}>{assignment.chapter_name}</Typography></TableCell>
                                <TableCell>
                                    <IconButton onClick={() => openReview(assignment)} sx={{ color: "#0091ea" }}>
                                        <Visibility />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}

                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default SubmitAssignment;
